import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    createStyles,
    Stack
} from '@mantine/core';

//import { fetchPosts } from '../actions/postsActions';
//import { Post } from '../components/Post';
import { Progress } from '@mantine/core';
import { useSelector } from 'react-redux';
import { FooterSimple } from '../components/FooterSimple';
import { MobileSimpleHeader } from '../components/MobileSimpleHeader';
import { CarCardDets } from '../components/CarCardDets';
import { InventoryList } from '../components/InventoryList';




import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
const useStyles = createStyles((theme) => ({
    cardAlign: {
        margin: '0 auto',
    },
    
}));

//this needs params
const AuctionItemPreviewDets = () => {
    const { classes } = useStyles();

    return (
        <>
            <MobileSimpleHeader 
                avatar={black_and_white_mercedes_benz}
                drawSubSectMenu={false}
            />
            <br/>
            <Stack
                align="center"
                justify="space-around"
            >
                <br/>
                <CarCardDets />
            </Stack>
        </>
    )

}

export default AuctionItemPreviewDets
